import React from "react";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { useStyles } from "./PaymentFailedPopup.style";
import { useTranslation } from "react-i18next";

interface PaymentFailedPopupProps {
  open: boolean;
  onClose: () => void;
}

export const PaymentFailedPopup: React.FC<PaymentFailedPopupProps> = (
  props,
) => {
  const { open, onClose } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      mainAction={{
        text: t("Payment_Ok"),
        onClick: onClose,
        id: "close-dialog",
        "data-gamepad": "default-selected",
        size: "large",
      }}
      className={classes.dialog}
    >
      <Typography
        variant={TypographyVariant.HeadingH3Bold}
        className={classes.title}
      >
        {t("Payment_Subscription Renewal Failed")}
      </Typography>

      <Typography
        variant={TypographyVariant.BodyB3Medium}
        color={TypographyColor.Default}
        className={classes.description}
      >
        {t(
          "Payment_There was an issue charging your payment method. You are currently in a grace period and can continue using the service, but please update your payment method to avoid any interruption.",
        )}
      </Typography>
    </Dialog>
  );
};
